// I've no idea what this does or why this is important
export const TelegramSymbols = {
    TelegramService: Symbol.for("TelegramService"),
    TelegramProvider: Symbol.for("TelegramProvider")
}